export enum DocumentActionStatusEnum {
    Validating = 'validating',
    ValidationFinished = 'validationFinished',
    Submitting = 'submitting',
    Canceling = 'canceling',
    Releasing = 'releasing',
    Saving = 'saving',
}
